import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { LangProvider } from "@/context/LangContext";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import CollectionPage from "@/pages/CollectionPage";
import ContattiPage from "@/pages/ContattiPage";
import { Toaster } from "@/components/ui/sonner";

// One-time migration: unregister the legacy FlashItalia24h service worker
// and purge its cache so returning PWA visitors immediately see the new site.
const purgeLegacyServiceWorker = () => {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  try {
    if (localStorage.getItem("simono_pwa_migrated") === "1") return;
  } catch {
    /* localStorage unavailable — proceed with best-effort purge */
  }
  const run = async () => {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
      if (window.caches && caches.keys) {
        const keys = await caches.keys();
        await Promise.all(keys.filter((k) => k !== "simon-o-v2").map((k) => caches.delete(k)));
      }
      try {
        localStorage.setItem("simono_pwa_migrated", "1");
      } catch {
        /* ignore */
      }
      await navigator.serviceWorker.register("/service-worker.js");
    } catch (err) {
      if (process.env.NODE_ENV === "development") {
        console.warn("SW migration skipped", err);
      }
    }
  };
  run();
};

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    purgeLegacyServiceWorker();
  }, []);

  return (
    <LangProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App bg-paper text-ink min-h-screen">
          <Nav />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/collezione/:slug" element={<CollectionPage />} />
              <Route path="/contatti" element={<ContattiPage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
